import React, { Component, useEffect, useState } from "react";
import { Form, Col, Row, Button } from "react-bootstrap";
import AddressDetails from "./addressComponent";
import { useForm,Controller } from "react-hook-form";
import ReactSelect from 'react-select';
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { createStudent, fetchLanguages,upadateStudentAction,openLoaderAction,closeLoaderAction, fetchBloodGroupsAction } from "../../../redux/actions/studentActions";
// import { branchDetailsAction } from "../../../redux/actions/feesActions";
import { Typeahead } from 'react-bootstrap-typeahead'; // ES2015
import { STUDENT, PARENT, EDIT_ACTION, ADMISSION_FORWARD, ADMISSION } from "../../constants";
import { customFormatOptions } from "../../../common/converters";
import { fetchBranchClassGroups, fetchBranchList, resetBranchLevelClassGroups } from "../../../redux/actions/feesActions";
import ImageUpload from '../../../common/ImageUpload'
import callApi from "../../../Api";
import PhoneInput,{formatPhoneNumber,formatPhoneNumberIntl ,isValidPhoneNumber ,isPossiblePhoneNumber} from 'react-phone-number-input'
import UserPhoneNumber from "../../../common/UserPhoneNumber";
import AwesomePhoneNumber from 'awesome-phonenumber';
import PhoneInputWithCountry from "react-phone-number-input/react-hook-form"
import CreatableSelect from 'react-select/creatable';



const StudentDetails = (props) => {
  const { changeTab , redirectFrom, studentData } = props;
  const dispatch = useDispatch();
  const { languagesList,studentProfileDetails ,bloodGroupsList } = useSelector((state) => state.student);
  const { branchList ,branchLevelClassGroups }  = useSelector(state => state.fees)
  const [languages,setLanguages] =useState([]);
  const [branchData, setBranchData] = useState([])
  const [profileFile, setProfileFile] = useState([])
  const [phone, setPhone] = useState(null)
  const [defaultCountry, setDefaultCountry] = useState("IN")


  const validationSchema = Yup.object().shape({
    BranchId: Yup.object().required("Branch Name is required").nullable(),
    // languages:Yup.object().required("Languages  required").nullable(),
    ClassGroupId: Yup.object().required("Admission For is Required").nullable(),
    academicStartDate: Yup.string().required("Start Date is Required"),
    academicEndDate: Yup.string().required("End Date is Required"),
    firstName: Yup.string().required("First Name is required"),
    lastName: Yup.string().required("Last Name is required"),
    email: Yup.string().required("Email is required").email("Email is invalid"),
    lastSchoolAttend: Yup.string().required("Last School Attend is required"),
    dob: Yup.string().required("Date Of Birth is required"),
    gender: Yup.object().required("Gender is required").nullable(),
    phoneNumber: Yup.string().required("Phone number is required").nullable(),
    religion: Yup.string().required("Religion is required"),
    caste: Yup.string().required("Caste is required"),
    BloodGroupId: Yup.object().required("Blood Group is required").nullable(),
    problemsOrFears: Yup.string().required("Problems Or Fears is required"),
    otherFee: Yup.string(),
    comment: Yup.string()
      .ensure()
      .when("otherFee", (otherFee) => {
        if(otherFee){
          return Yup.string().required("Must enter comment")
        }
          
      }),
    taxBenfits: Yup.string().required("TaxBenfits is required"),


    addressLine: Yup.string().required("Address  is required"),
    city: Yup.string().required("City For is Required"),
    district: Yup.string().required("Districtis required"),
    StateId: Yup.object().required("State is required").nullable(),
    postalCode: Yup.string().min(6, 'Zip Code must b 6 digits').max(6, 'Zip Code should not be greater than 6 digits').required("Zip is required"),
    distanceFromSchool: Yup.string().required("Distance From School is required"),
  });
  console.log(studentData)
  const {
    register,
    handleSubmit,
    reset,
    setError,clearErrors,setValue,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: {
      taxBenfits: "false",
      // city
      ...studentData

    },
    resolver: yupResolver(validationSchema),
  });


  // console.log(selectionRange)
  useEffect(() => {
    async function fetchGroups() {
      await dispatch(fetchLanguages());
      await dispatch(fetchBranchList());
      await dispatch(fetchBloodGroupsAction())
    }
    
    fetchGroups();
    if(redirectFrom === EDIT_ACTION){
      setLanguages(studentData.languages)
      setPhone(studentData.phoneNumber)
      setDefaultCountry("IN")
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // useEffect(() => {
  //   if(redirectFrom === EDIT_ACTION){
  //     setLanguages(studentData.languages)
  //   }
  // }, [])
  useEffect(async () => {
    setBranchData(customFormatOptions(branchList,'id','name'));
  }, [branchList]);
  const onSubmit = async (data) => {
   console.log(data)
    const reqParams = {
      ...data
    }
    reqParams.BranchId = data.BranchId.value;
    reqParams.ClassGroupId = data.ClassGroupId.value;
    reqParams.StateId = data.StateId.value;
    reqParams.gender = data.gender.value;
    reqParams.BloodGroupId = data.BloodGroupId.value;
    const pn = new AwesomePhoneNumber( `${data.phoneNumber}`, 'IN' );
    reqParams.phoneNumber = pn.getNumber( 'significant' ); 
      let userData = {};
      dispatch(openLoaderAction());
      if(redirectFrom === EDIT_ACTION && Object.keys(studentProfileDetails).length > 0 && studentProfileDetails.User.email !== data.email ){
        userData = await callApi.get("user/email_availability",{params: {
          email:data.email
        }});
        dispatch(closeLoaderAction());
      }
      if(redirectFrom === ADMISSION) {
        userData = await callApi.get("user/email_availability",{params: {
          email:data.email
        }});
        dispatch(closeLoaderAction());
      }
      
      if(Object.keys(userData).length > 0 &&  userData.data.data){
        setError("email", { type: "focus",message: "Email was already used", }, { shouldFocus: true });
      }else{
        const studentReqObj = new FormData();
        if(Object.keys(profileFile).length > 0){
          studentReqObj.append('avatar', profileFile, profileFile.name);
        }
        await Object.keys(reqParams).forEach(obj=>{
          studentReqObj.append(`${obj}`, reqParams[`${obj}`]);
        })
        clearErrors(["email"])
        if(redirectFrom === EDIT_ACTION){
          studentReqObj.append('StudentId', studentData.id);
          studentReqObj.append('languages', JSON.stringify(languages));
          // studentReqObj.append('address', data.address);
          // reqParams.StudentId = studentData.id
          // await dispatch(upadateStudentAction({...reqParams,languages,address:data.address}));
          await dispatch(upadateStudentAction(studentReqObj));
        } else{
          studentReqObj.append('languages', JSON.stringify(languages));
          // studentReqObj.append('address', data.address);
          // await dispatch(createStudent({...reqParams,languages,address:data.address}));
          await dispatch(createStudent(studentReqObj));
          reset();
          changeTab(PARENT)
      }
      
    }
    
  };

  const handleLanguageSelection = (selected) => {
    console.log(selected)
    setLanguages(selected)
  }
  const handleSelect =(ranges)=>{
    // {
    //   selection: {
    //     startDate: [native Date Object],
    //     endDate: [native Date Object],
    //   }
    // }
  }
const onChangeAction = async(data)=>{
  setValue("BranchId", data);
  await dispatch(resetBranchLevelClassGroups())
  setValue("ClassGroupId", null);
  if (data && data.value ) {

    await dispatch(fetchBranchClassGroups({
      BranchId: data.value,
      disabled: false
    }))
    
    }
}
const uploadFiles = (files)=>{
  setProfileFile(files)
}
const onError = async(data)=>{
  console.log(data)
}
const handlePhoneValidation =(phoneObj)=>{
  console.log(phoneObj)
  if(Object.keys(phoneObj).length > 0){
    setPhone(phoneObj.data)
    if(phoneObj.isValid){
      clearErrors("phoneNumber");
      setValue("phoneNumber",phoneObj.data)
    }else{
      setError("phoneNumber", { type: "focus",message: "Invalid Phone number", }, { shouldFocus: true });
    } 
  }else{
    setPhone(phoneObj.data)
    setValue("phoneNumber",null)
    setError("phoneNumber", { type: "focus",message: "Phone number is required", }, { shouldFocus: true });
  }
}
  return (
    <>
      <Form noValidate onSubmit={handleSubmit(onSubmit,onError)} >
      <Form.Row>
          <Form.Group
            className={`col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 required `}
            controlId="formFirstName" 
          >
            <Form.Label className="label">Branch Name</Form.Label>
            <Controller
                  name="BranchId"
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <>
                      <ReactSelect
                        isClearable
                        {...field}
                        options={branchData}
                        className={`${errors.BranchId ? "is-invalid" : ""}`}
                        isOptionDisabled={(option) => option.disabled}
                        onChange={onChangeAction}
                        isDisabled={redirectFrom === EDIT_ACTION}
                      />
                      <span className="invalid-feedback">
                        {errors.BranchId?.message}
                      </span>
                    </>
                  )}
                  {...register("BranchId")}
                />
          </Form.Group>
          <Form.Group
            className="col-xs-12 col-sm-12 col-md-4 offset-md-2 col-lg-4 offset-lg-2 col-xl-4 offset-xl-2 required"
            controlId="formLastName"
          >
            <Form.Label className="label">Admission For</Form.Label>
            
               <Controller
                  name="ClassGroupId"
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <>
                      <ReactSelect
                        isClearable
                        {...field}
                        options={branchLevelClassGroups}
                        className={`${errors.ClassGroupId ? "is-invalid" : ""}`}
                        isOptionDisabled={(option) => option.disabled}
                        isDisabled={redirectFrom === EDIT_ACTION}
                      />
                      <span className="invalid-feedback">
                        {errors.ClassGroupId?.message}
                      </span>
                    </>
                  )}
                  {...register("ClassGroupId")}
                />
          </Form.Group>
        </Form.Row>
        <Form.Row>
          <Form.Group
            className="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 required"
            controlId="bloodGroup"
          >
            <Form.Label className="label">Academic Start Date</Form.Label>
            <Form.Control
              type="date"
              name="academicStartDate"
              className={`form-control ${errors.academicStartDate ? "is-invalid" : ""}`}
              {...register("academicStartDate")}
            />
            <span className="invalid-feedback">
              {errors.academicStartDate?.message}
            </span>
          </Form.Group>
          <Form.Group
            className="col-xs-12 col-sm-12 col-md-4 offset-md-2 col-lg-4 offset-lg-2 col-xl-4 offset-xl-2 required"
            controlId="admitFor"
          >
            <Form.Label>Academic End Date</Form.Label>
           <Form.Control
              type="date"
              name="academicEndDate"
              className={`form-control ${errors.academicEndDate ? "is-invalid" : ""}`}
              {...register("academicEndDate")}
            />
            <span className="invalid-feedback">
              {errors.academicEndDate?.message}
            </span>
          </Form.Group>
        </Form.Row>
        <Form.Row>
          <Form.Group
            className={`col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 required `}
            controlId="formFirstName" 
          >
            <Form.Label className="label">First Name</Form.Label>
            <Form.Control
              type="text"
              name="firstName"              
              {...register("firstName")}
              className={`form-control ${errors.firstName ? "is-invalid" : ""}`}
            />
            <span className="invalid-feedback">
              {errors.firstName?.message}
            </span>
          </Form.Group>
          <Form.Group
            className="col-xs-12 col-sm-12 col-md-4 offset-md-2 col-lg-4 offset-lg-2 col-xl-4 offset-xl-2 required"
            controlId="formLastName"
          >
            <Form.Label className="label">Last Name</Form.Label>
            <Form.Control
              type="text"
              name="lastName"
              className={`form-control ${errors.lastName ? "is-invalid" : ""}`}
              {...register("lastName")}
            />
            <span className="invalid-feedback">
              {errors.lastName?.message}
            </span>
          </Form.Group>
        </Form.Row>
        <Form.Row>
          <Form.Group
            className="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 required"
            controlId="formFirstName"
          >
            <Form.Label className="label">Email</Form.Label>
            <Form.Control
              type="email"
              name="email"
              className={`form-control ${errors.email ? "is-invalid" : ""}`}
              {...register("email")}
            />
            <span className="invalid-feedback">
              {errors.email?.message}
            </span>
          </Form.Group>
          <Form.Group
            className="col-xs-12 col-sm-12 col-md-4 offset-md-2 col-lg-4 offset-lg-2 col-xl-4 offset-xl-2 required"
            controlId="telephone"
          >
            <Form.Label className="label">Mother Telephone No</Form.Label>
            <UserPhoneNumber isRequired={false} errorClass={`form-control ${errors.phoneNumber ? "is-invalid" : ""}`} onInputChange={handlePhoneValidation} value={ phone } />
            {/* <Controller
            name="phoneNumber"
            control={control}
            render={({ field }) => (
              <PhoneInput
            defaultCountry={defaultCountry}
            placeholder="Enter phone number"
            value={phone}
            onChange={handlePhoneValidation}
            className={`form-control ${errors.phoneNumber ? "is-invalid" : ""}`}
            international={false}
            countryCallingCodeEditable={false}
            />
            )}
          />
          <span className="invalid-feedback">
              {errors.phoneNumber?.message}
            </span> */}
            
            {/* <Form.Control
              type="text"
              name="telephone"
              className={`form-control ${errors.phoneNumber ? "is-invalid" : ""}`}
              {...register("phoneNumber")}
            /> */}
            <span className="invalid-feedback">
              {errors.phoneNumber?.message}
            </span>
          </Form.Group>
          
        </Form.Row>
        <Form.Row>
          <Form.Group
            className="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 required"
            controlId="dob"
          >
            <Form.Label className="label">Date of Birth</Form.Label>
            <Form.Control
              type="date"
              name="dob"
              className={`form-control ${errors.dob ? "is-invalid" : ""}`}
              {...register("dob")}
            />
            <span className="invalid-feedback">
              {errors.dob?.message}
            </span>
          </Form.Group>
          <Form.Group
            className="col-xs-12 col-sm-12 col-md-4 offset-md-2 col-lg-4 offset-lg-2 col-xl-4 offset-xl-2 required"
            controlId="age"
          >
            <Form.Label className="label">Language Spoken At Home</Form.Label>
            {/* <Controller
                  name="BranchId"
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <>
                      <CreatableSelect
                        isMulti
                        isClearable
                        {...field}
                        onChange={handleLanguageSelection}
                        className={`${errors.languages ? "is-invalid" : ""}`}
                        options={languagesList}
                        value={languages}
                        placeholder="Type language name..."
                      />
                      <span className="invalid-feedback">
                        {errors.languages?.message}
                      </span>
                    </>
                  )}
                  {...register("languages")}
                /> */}
            
            <Typeahead
              allowNew
              id="custom-selections-example"
              multiple
              onChange={handleLanguageSelection}
              newSelectionPrefix="Add a new language: "
              options={languagesList}
              placeholder="Type language name..."
              selected={languages}
            />
            <span className="invalid-feedback">
              {errors.languages?.message}
            </span>
          </Form.Group>
        </Form.Row>
        <Form.Row>
          <Form.Group
            className="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 required"
            controlId="sex"
          >
            <Form.Label>Sex</Form.Label>
            <Controller
                  name="gender"
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <>
                      <ReactSelect
                        isClearable
                        {...field}
                        options={[{
                          value:"Male",label: "Male"
                        },{
                          value:"Female",label: "Female"
                        }]}
                        className={`${errors.gender ? "is-invalid" : ""}`}
                        isOptionDisabled={(option) => option.disabled}
                        // onChange={onChangeAction}
                      />
                      <span className="invalid-feedback">
                        {errors.gender?.message}
                      </span>
                    </>
                  )}
                  {...register("gender")}
                />
            
          </Form.Group>

          <Form.Group
            className="col-xs-12 col-sm-12 col-md-4 offset-md-2 col-lg-4 offset-lg-2 col-xl-4 offset-xl-2 required"
            controlId="formLastName"
          >
            <Form.Label className="label">Last School Attend</Form.Label>
            <Form.Control
              type="text"
              name="lastSchoolAttend"
              className={`form-control ${errors.lastSchoolAttend ? "is-invalid" : ""}`}
              {...register("lastSchoolAttend")}
            />
            <span className="invalid-feedback">
              {errors.lastSchoolAttend?.message}
            </span>
          </Form.Group>
        </Form.Row>
        <Form.Row>
          <Form.Group
            className="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 required"
            controlId="religion"
          >
            <Form.Label className="label">Religion</Form.Label>
            <Form.Control
              type="text"
              name="religion"
              className={`form-control ${errors.religion ? "is-invalid" : ""}`}
              {...register("religion")}
            />
            <span className="invalid-feedback">
              {errors.religion?.message}
            </span>
          </Form.Group>
          <Form.Group
            className="col-xs-12 col-sm-12 col-md-4 offset-md-2 col-lg-4 offset-lg-2 col-xl-4 offset-xl-2 required"
            controlId="caste"
          >
            <Form.Label className="label">Caste</Form.Label>
            <Form.Control
              type="text"
              name="caste"
              className={`form-control ${errors.caste ? "is-invalid" : ""}`}
              {...register("caste")}
            />
            <span className="invalid-feedback">
              {errors.caste?.message}
            </span>
          </Form.Group>
        </Form.Row>
        <Form.Row>
          <Form.Group
            className="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 required"
            controlId="bloodGroup"
          >
            <Form.Label className="label">Blood Group</Form.Label>
            {/* <Form.Control
              type="text"
              name="bloodGroup"
              className={`form-control ${errors.bloodGroup ? "is-invalid" : ""}`}
              {...register("bloodGroup")}
            /> */}
            <Controller
                  name="BloodGroupId"
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <>
                      <ReactSelect
                        isClearable
                        {...field}
                        options={bloodGroupsList}
                        className={`${errors.BloodGroupId ? "is-invalid" : ""}`}
                      />
                      <span className="invalid-feedback">
                        {errors.BloodGroupId?.message}
                      </span>
                    </>
                  )}
                  {...register("BloodGroupId")}
                />
            {/* <span className="invalid-feedback">
              {errors.BloodGroupId?.message}
            </span> */}
          </Form.Group>
          <Form.Group
            className="col-xs-12 col-sm-12 col-md-4 offset-md-2 col-lg-4 offset-lg-2 col-xl-4 offset-xl-2 required"
            controlId="admitFor"
          >
            <Form.Label className="label">
              Does your child have any special Problems or Fears?
            </Form.Label>
            <Form.Control
              type="text"
              name="problemsOrFears"
              className={`form-control ${errors.problemsOrFears ? "is-invalid" : ""}`}
              {...register("problemsOrFears")}
            />
            <span className="invalid-feedback">
              {errors.problemsOrFears?.message}
            </span>
          </Form.Group>
        </Form.Row>
        <Form.Row>
        
          <Form.Group
            className="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 "
            controlId="formFirstName"
          >
            
            { redirectFrom === EDIT_ACTION ? null : (
                <Form.Group
                as={Row}
                className="mb-3"
                controlId="formPlaintextEmail"
                >
                <Form.Label column sm="6">
                  Pay for 
                </Form.Label>
                <Col sm="6">
                  <Form.Control
                type="number"
                name="otherFee"
                min="0"
                className={`form-control ${errors.otherFee ? "is-invalid" : ""}`}
                {...register("otherFee")}
                disabled={redirectFrom === EDIT_ACTION}
                />
                <span className="invalid-feedback">
                {errors.otherFee?.message}
                </span>
                  
                </Col>
                </Form.Group>
                )}
            <div className="spacer"></div>
            <Form.Group
              as={Row}
              className="mb-3"
              controlId="formPlaintextEmail"
            >
              <Form.Label column sm="6">
                Income Tax Deduction
              </Form.Label>
              <Col sm="6">
                <Form.Check
                  inline
                  label="Yes"
                  type="radio"
                  id={`inline-yes`}
                  name="taxBenfits"
                  value={true}
                  className={` ${errors.taxBenfits ? "is-invalid" : ""}`}
                  {...register("taxBenfits")}
                />
                <Form.Check
                  inline
                  label="No"
                  type="radio"
                  id={`inline-yes`}
                  name="taxBenfits"
                  value={false}
                  className={`${errors.taxBenfits ? "is-invalid" : ""}`}
                  {...register("taxBenfits")}
                />
                <span className="invalid-feedback">
                  {errors.taxBenfits?.message}
                </span>
              </Col>
            </Form.Group>
            
          </Form.Group>
          <Form.Group
            className="col-xs-12 col-sm-12 col-md-4 offset-md-2 col-lg-4 offset-lg-2 col-xl-4 offset-xl-2"
            controlId="formLastName"
          >
            { redirectFrom === EDIT_ACTION ? (
              <>
              {/* <ImageUpload uploadFile={uploadFiles}/> */}
              </>
            ) : (
              <>
              <Form.Label>comment </Form.Label>
              <Form.Control
                as="textarea"
                name="comment"
                rows={3}
                //   defaultValue={this.props.inputValues.state}
                //   onChange={this.props.handleChange}
                className={`form-control ${errors.comment ? "is-invalid" : ""}`}
                {...register("comment")}
                disabled={redirectFrom === EDIT_ACTION}
              >
                
              </Form.Control>
              <span className="invalid-feedback">
                {errors.comment?.message}
              </span>
              </>
            )}
            
            
          </Form.Group>
        </Form.Row>
        <AddressDetails register={register} errors={errors} addressType={STUDENT} control={control} />
        {
          (redirectFrom === EDIT_ACTION || redirectFrom === ADMISSION_FORWARD) ? null :  (
            <>
            <Form.Row>
              <Form.Group
                className="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 required" controlId="bloodGroup"
              >
                {/* <Form.Label className="label">Upload Profile Photo</Form.Label> */}
                <ImageUpload uploadFile={uploadFiles} isPreviewRequired={true} fileData={profileFile}/>
                
              </Form.Group>
            </Form.Row>
            </>
          )
        }

        <div >
          <Button
            variant="btn app-default-button btn btn-primary"
            type="submit"
          >
            { redirectFrom === EDIT_ACTION ? "Update" : "Submit" }
          </Button>
        </div>
      </Form>
    </>
  );
};

export default StudentDetails;
